// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 퀘스트 광장 큰 TV 스타일 — 풀스크린, 대형 폰트, 화려한 연출.
 * 모든 클래스는 .qs-page 하위로 스코프해 다른 화면과 충돌 방지.
 * 단위는 vw/vmin 위주 → TV 해상도(1080p/4K)에 따라 자동 스케일.
 */

.qs-viewport {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #101610;
  isolation: isolate;
}

/* 1200×1920 피그마 캔버스 밖의 여백은 동일 화면의 색감으로만 채운다. */
.qs-ambient-background {
  position: absolute;
  z-index: 0;
  inset: -5%;
  overflow: hidden;
  background: #101610;
  pointer-events: none;
}

.qs-ambient-background::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(4, 12, 6, 0.3);
}

.qs-ambient-background img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(32px) saturate(0.82) brightness(0.72);
  transform: scale(1.08);
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

/* 현장 디스플레이가 왼쪽으로 눕힌 세로형이므로 주키퍼 본부 전체를 반시계 방향으로 회전한다. */
.qs-page {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  width: 100vh;
  height: 160vh;
  flex: none;
  transform: translate(-50%, -50%) rotate(-90deg);
  transform-origin: center;
  overflow: hidden;
  background: radial-gradient(circle at 50% 30%, #134e4a 0%, #042f2e 70%, #021917 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

/* 개발 중 세로 시안을 바로 확인하는 미리보기. 기본 현장 회전값은 유지한다. */
.qs-page.qs-page--dev-upright {
  /* 논리 크기는 실전 회전 화면과 동일하게 두고 전체를 축소해 비율·vmin을 보존한다. */
  width: 100vh;
  height: 160vh;
  transform: translate(-50%, -50%) scale(0.625);
}

.qs-hidden-home-exit {
  position: fixed;
  z-index: 100002;
  top: 0;
  left: 0;
  width: 96px;
  height: 96px;
  padding: 0;
  border: 0;
  background: transparent;
  opacity: 0;
  -webkit-tap-highlight-color: transparent;
}

.qs-dev-toolbar {
  position: fixed;
  z-index: 100001;
  left: 18px;
  bottom: 18px;
  display: grid;
  min-width: 420px;
  gap: 10px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 20px;
  background: linear-gradient(145deg, rgba(15, 23, 42, 0.94), rgba(25, 39, 35, 0.92));
  color: #fff;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  -webkit-tap-highlight-color: transparent;
}

.qs-dev-toolbar-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 4px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  letter-spacing: -0.01em;
}

.qs-dev-toolbar-heading strong {
  font-size: 14px;
  font-weight: 800;
}

.qs-dev-menu-home {
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-left: auto;
  padding: 0 9px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.09);
  color: #f8fafc;
  font-family: inherit;
  font-size: 12px;
  font-weight: 850;
  line-height: 1;
  cursor: pointer;
  transition: background 130ms ease, transform 130ms ease;
}

.qs-dev-menu-home:hover {
  background: rgba(255, 255, 255, 0.17);
}

.qs-dev-menu-home:active {
  transform: translateY(1px) scale(0.97);
}

.qs-dev-menu-home:focus-visible {
  outline: 2px solid #facc15;
  outline-offset: 2px;
}

.qs-dev-menu-home svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.qs-dev-toolbar-badge {
  padding: 4px 7px;
  border-radius: 7px;
  background: linear-gradient(135deg, #a3e635, #22c55e);
  color: #102218;
  font-size: 11px;
  font-weight: 950;
  line-height: 1;
  letter-spacing: 0.08em;
}

.qs-dev-toolbar-actions {
  display: flex;
  gap: 8px;
}

.qs-dev-tool-button {
  display: inline-flex;
  min-width: 0;
  height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 13px;
  color: #f8fafc;
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 5px 12px rgba(0, 0, 0, 0.18);
  transition: transform 130ms ease, filter 130ms ease, border-color 130ms ease;
}

.qs-dev-tool-button:hover {
  border-color: rgba(255, 255, 255, 0.3);
  filter: brightness(1.08);
}

.qs-dev-tool-button:active {
  transform: translateY(2px) scale(0.98);
  filter: brightness(0.92);
}

.qs-dev-tool-button:focus-visible {
  outline: 3px solid #facc15;
  outline-offset: 2px;
}

.qs-dev-qr-button--incomplete {
  background: linear-gradient(145deg, #2563eb, #1d4ed8);
}

.qs-dev-qr-button--complete {
  background: linear-gradient(145deg, #f97316, #ea580c);
}

.qs-dev-tool-status {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);
}

.qs-dev-tool-check {
  display: grid;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #c2410c;
  font-size: 13px;
  font-weight: 950;
}

.qs-dev-orientation-toggle {
  margin-left: auto;
  background: linear-gradient(145deg, #334155, #1e293b);
}

.qs-dev-orientation-toggle svg {
  display: block;
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: currentColor;
  transition: transform 180ms ease;
}

.qs-dev-orientation-toggle.is-upright svg {
  transform: rotate(90deg);
}

.qs-dev-home-button {
  background: linear-gradient(145deg, #15803d, #166534);
}

.qs-dev-home-button svg {
  display: block;
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: currentColor;
}

/* ── 대기 화면 ── */
.qs-page .qs-idle {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;
}

.qs-page .qs-screen-frame {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  contain: layout paint;
  isolation: isolate;
}

.qs-page .qs-idle-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.qs-page .qs-waiting-screen-loading {
  width: 100%;
  height: 100%;
  background: #000;
}

.qs-page .qs-waiting-screen-error {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  padding: 32px;
  color: #fff;
  background: #101b12;
  font-size: clamp(24px, 3vw, 48px);
  text-align: center;
}

/* 선물 받기 직후 정적 배경·큐브를 대체하는 5초 오픈 연출. 로고와 버튼은 상위 레이어에 유지한다. */
.qs-page .qs-gift-opening-video {
  position: absolute;
  z-index: 1;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  pointer-events: none;
  transform: none;
}

.qs-page .qs-gift-opening-video.is-playing {
  animation: qs-gift-opening-reveal 240ms ease-out both;
}

.qs-page .qs-gift-opening-video.is-final {
  opacity: 1;
}

/* 완료 영상 종료 뒤 큐브 영상의 첫 프레임만 정지 상태로 보여준다. */
.qs-page .qs-gift-opening-video.is-ready {
  opacity: 1;
}

/* 은화 획득 단계는 별도 UI 없이 영상만 전면에 노출한다. */
.qs-page .qs-silver-reward-video,
.qs-page .qs-coupon-reveal-video,
.qs-page .qs-egg-hatch-video {
  z-index: 3;
}

/* 마지막 프레임 위에 말풍선(z-index 2)과 확인 버튼(z-index 4)을 올린다. */
.qs-page .qs-animal-reveal-video {
  z-index: 1;
}

/* 피그마에서 분리 전달된 보상 화면 레이어. */
.qs-page .qs-reward-headline-image {
  position: absolute;
  z-index: 2;
  right: 0;
  left: 0;
  height: auto;
  margin-inline: auto;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  backface-visibility: hidden;
  -webkit-user-drag: none;
}

.qs-page .qs-reward-headline-image--complete-character {
  top: 5.2%;
  width: 76%;
}

.qs-page .qs-reward-headline-image--coin,
.qs-page .qs-reward-headline-image--coupon,
.qs-page .qs-reward-headline-image--egg {
  top: 4.1667%;
  width: 86.6667%;
}

/* 문구가 합쳐진 시안 대신 빈 말풍선 위에 서버의 실제 보상값을 표시한다. */
.qs-page .qs-reward-dynamic-headline {
  position: absolute;
  z-index: 2;
  top: 4.1667%;
  right: 0;
  left: 0;
  width: 86.6667%;
  height: auto;
  margin-inline: auto;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  backface-visibility: hidden;
}

.qs-page .qs-reward-dynamic-headline-bubble {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.qs-page .qs-reward-dynamic-headline-text {
  position: absolute;
  top: 5%;
  right: 7%;
  bottom: 22%;
  left: 7%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  overflow: hidden;
  color: #079719;
  font-family: 'Jua', 'Noto Sans KR', sans-serif;
  font-size: clamp(56px, 9vmin, 104px);
  font-weight: 700;
  line-height: 1.04;
  text-align: center;
  text-wrap: balance;
  word-break: keep-all;
  filter: drop-shadow(0 0.08em 0 rgba(255, 255, 255, 0.55));
}

.qs-page .qs-reward-hero {
  --qs-reward-float-duration: 3.4s;
  --qs-reward-float-y: -5%;
  --qs-reward-float-tilt: 0.8deg;
  --qs-reward-float-tilt-reverse: -0.55deg;
  position: absolute;
  z-index: 2;
  right: 0;
  left: 0;
  height: auto;
  margin-inline: auto;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  backface-visibility: hidden;
  isolation: isolate;
}

.qs-page .qs-reward-hero--complete-character {
  --qs-reward-float-duration: 3.6s;
  --qs-reward-float-y: -2.6%;
  --qs-reward-float-tilt: 0.75deg;
  --qs-reward-float-tilt-reverse: -0.5deg;
  top: 25.5%;
  width: 62%;
}

.qs-page .qs-reward-hero--opening {
  animation: qs-gift-opening-static-fade 240ms ease-out both;
}

.qs-page .qs-reward-hero--coin,
.qs-page .qs-reward-hero--coupon,
.qs-page .qs-reward-hero--egg {
  --qs-reward-float-duration: 3.45s;
  --qs-reward-float-y: -5%;
  --qs-reward-float-tilt: 1.15deg;
  --qs-reward-float-tilt-reverse: -0.85deg;
}

.qs-page .qs-reward-hero--coin {
  top: 27.5%;
  width: 68.3333%;
}

.qs-page .qs-reward-hero--coupon {
  top: 27.5%;
  width: 52.7292%;
}

.qs-page .qs-reward-hero--egg {
  top: 29%;
  width: 55%;
}

/* 모바일과 같은 animal_profile.image_url 대체 노출. 전용 획득 영상이 없는 동물만 사용한다. */
.qs-page .qs-animal-profile-fallback {
  position: absolute;
  z-index: 2;
  top: 27.5%;
  left: 50%;
  display: flex;
  width: 56%;
  aspect-ratio: 1;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 2.4%;
  overflow: hidden;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1.2rem 2rem rgba(61, 35, 25, 0.18);
  transform: translateX(-50%);
  animation: qs-reward-pop-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.qs-page .qs-animal-profile-fallback img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

/* 오브젝트 높이에 맞춰 작아졌다 커지는 그림자로 부유감을 보강한다. */
.qs-page .qs-reward-hero::after {
  content: '';
  position: absolute;
  z-index: 0;
  right: 22%;
  bottom: -3.5%;
  left: 22%;
  height: 7%;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(54, 24, 17, 0.28) 0%, rgba(54, 24, 17, 0) 72%);
  transform-origin: center;
  animation: qs-reward-float-shadow var(--qs-reward-float-duration) ease-in-out infinite;
}

.qs-page .qs-reward-hero--tada {
  animation: qs-reward-pop-in 620ms cubic-bezier(0.22, 1, 0.36, 1) backwards;
}

.qs-page .qs-reward-hero--tada .qs-reward-hero-image {
  animation-delay: 640ms;
}

.qs-page .qs-reward-hero--tada::after {
  animation-delay: 640ms;
}

/* 보상 오브젝트는 첫 등장 연출만 사용하고, 노출 후에는 제자리에 멈춘다. */
.qs-page .qs-reward-hero--coin .qs-reward-hero-image,
.qs-page .qs-reward-hero--coupon .qs-reward-hero-image,
.qs-page .qs-reward-hero--egg .qs-reward-hero-image {
  animation: none;
}

.qs-page .qs-reward-hero--coin::after,
.qs-page .qs-reward-hero--coupon::after,
.qs-page .qs-reward-hero--egg::after {
  display: none;
}

.qs-page .qs-reward-hero-image {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  animation: qs-reward-float var(--qs-reward-float-duration) ease-in-out infinite;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  will-change: transform;
  -webkit-user-drag: none;
}

.qs-page .qs-reward-button-visual {
  position: absolute;
  z-index: 4;
  display: block;
  left: 15%;
  right: 15%;
  bottom: 4.1667%;
  width: auto;
  height: 14.5833%;
  min-height: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  line-height: 0;
  cursor: pointer;
  pointer-events: auto;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.qs-page .qs-reward-button-visual.is-pressed .qs-reward-button-image {
  animation: qs-reward-button-press 220ms ease-out both;
}

.qs-page .qs-reward-button-image {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
  cursor: pointer;
  pointer-events: auto;
  -webkit-user-select: none;
          user-select: none;
  transform-origin: center;
  backface-visibility: hidden;
  will-change: transform;
  -webkit-user-drag: none;
}

/* 저사양 태블릿의 지도 이동 중에는 전체 화면 32px 블러 합성 비용을 제거한다. */
.qs-viewport--mission-map .qs-ambient-background img {
  filter: saturate(0.82) brightness(0.64);
}

/* 버튼 이미지 요소 자체를 클릭 영역으로 사용해 보이는 크기와 hit box를 일치시킨다. */
.qs-page .qs-image-action {
  cursor: pointer;
}

.qs-page .qs-image-action:focus-visible {
  outline: 4px solid rgba(255, 255, 255, 0.9);
  outline-offset: 4px;
}

.qs-page .qs-image-action:disabled {
  cursor: default;
}

@keyframes qs-reward-pop-in {
  0% {
    opacity: 0;
    transform: translate3d(0, 7%, 0);
  }
  58% {
    opacity: 1;
    transform: translate3d(0, -1.4%, 0);
  }
  80% {
    transform: translate3d(0, 0.5%, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes qs-gift-opening-reveal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes qs-gift-opening-static-fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes qs-reward-float {
  0%,
  100% {
    transform: translate3d(0, 1%, 0) rotate(var(--qs-reward-float-tilt-reverse));
  }
  50% {
    transform: translate3d(0, var(--qs-reward-float-y), 0) rotate(var(--qs-reward-float-tilt));
  }
}

@keyframes qs-reward-float-shadow {
  0%,
  100% {
    opacity: 0.28;
    transform: scale3d(1, 0.82, 1);
  }
  50% {
    opacity: 0.12;
    transform: scale3d(0.72, 0.58, 1);
  }
}

@keyframes qs-reward-button-press {
  0% {
    transform: scale(1);
  }
  45% {
    transform: scale(0.94);
  }
  100% {
    transform: scale(1.02);
  }
}

@media (prefers-reduced-motion: reduce) {
  .qs-page .qs-reward-hero--tada,
  .qs-page .qs-reward-hero--opening,
  .qs-page .qs-gift-opening-video.is-playing,
  .qs-page .qs-reward-hero-image,
  .qs-page .qs-reward-hero::after,
  .qs-page .qs-reward-button-visual.is-pressed .qs-reward-button-image {
    animation: none;
  }

  .qs-page .qs-gift-opening-video.is-playing {
    opacity: 1;
  }

  .qs-page .qs-reward-hero--opening {
    opacity: 0;
  }
}

@media (max-width: 720px) {
  .qs-dev-toolbar {
    left: 10px;
    bottom: 10px;
    min-width: 0;
    max-width: calc(100vw - 20px);
    transform: scale(0.9);
    transform-origin: left bottom;
  }

  .qs-dev-tool-button {
    padding-inline: 10px;
    font-size: 12px;
  }
}

.qs-page .qs-idle-busy {
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0.5em 0.9em;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.66);
  font-size: 3vmin;
  font-weight: 700;
  color: #fcd34d;
  white-space: nowrap;
}

/* ── QR 회원별 실제 미션 진행 지도 ── */
.qs-page .qs-progress {
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  padding: 0;
  background: #6f8f4a;
  color: #fff;
  pointer-events: auto;
  isolation: isolate;
}


/* 지도와 문구가 숲 배경에 묻히지 않으면서 원본 일러스트는 보이게 한다. */
.qs-page .qs-progress::after {
  content: '';
  position: absolute;
  z-index: 0;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(34, 76, 30, 0.18) 0%,
    rgba(61, 101, 43, 0.06) 48%,
    rgba(25, 62, 25, 0.2) 100%
  );
}

.qs-page .qs-progress-header {
  position: absolute;
  z-index: 6;
  top: 3.6%;
  right: 5.2%;
  left: 5.2%;
  height: 7.1%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 2.7%;
  border-radius: clamp(15px, calc(2.1 * var(--qs-progress-vmin)), 28px);
  background: #005b08;
  box-shadow: 0 calc(0.45 * var(--qs-progress-vmin)) calc(1.15 * var(--qs-progress-vmin)) rgba(20, 55, 20, 0.24);
  color: #fff;
  font-family: 'AndongKaturi', sans-serif;
  font-size: clamp(30px, calc(4.4 * var(--qs-progress-vmin)), 56px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.02em;
}

.qs-page .qs-progress-header strong {
  flex: none;
  color: #fff;
  font: inherit;
  font-variant-numeric: tabular-nums;
}

.qs-page .qs-progress-map-area {
  position: absolute;
  z-index: 1;
  inset: 0;
  min-height: 0;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0;
  touch-action: none;
  cursor: grab;
  -webkit-tap-highlight-color: transparent;
}

.qs-page .qs-progress-map-area:active {
  cursor: grabbing;
}

/* 이미지 자체가 좌표계다. 핀의 left/top %가 뷰포트 여백 때문에 어긋나지 않게 한다. */
.qs-page .qs-progress-map-canvas {
  position: relative;
  width: 100%;
  flex: none;
  line-height: 0;
  overflow: visible;
  transform-origin: 0 0;
  transition: transform 0.42s cubic-bezier(0.2, 0.8, 0.2, 1);
  will-change: transform;
  backface-visibility: hidden;
  isolation: isolate;
}

.qs-page .qs-progress-map-area:active .qs-progress-map-canvas {
  transition: none;
}

.qs-page .qs-progress-map-image {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 0;
  -webkit-user-select: none;
          user-select: none;
  mask-image: linear-gradient(
    90deg,
    transparent 0%,
    #000 2.5%,
    #000 97.5%,
    transparent 100%
  );
  -webkit-user-drag: none;
}

.qs-page .qs-progress-pin {
  --qs-pin-size: clamp(46px, calc(6.2 * var(--qs-progress-vmin)), 82px);
  --qs-pin-zoom-compensation: var(--qs-map-inverse-scale, 1);
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate3d(
    calc(-50% + var(--qs-pin-dx, 0px)),
    calc(-100% + var(--qs-pin-dy, 0px)),
    0
  ) scale(var(--qs-pin-zoom-compensation));
  transform-origin: 50% 100%;
  filter: drop-shadow(0 0.12em 0.2em rgba(0, 0, 0, 0.42));
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  line-height: 1;
  -webkit-tap-highlight-color: transparent;
  transition: filter 0.2s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.qs-page .qs-progress-pin-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--qs-pin-size);
  height: var(--qs-pin-size);
  padding: calc(var(--qs-pin-size) * 0.12);
  box-sizing: border-box;
  border-radius: 32%;
  background: #fff;
}

.qs-page .qs-progress-pin-glyph {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 16%;
  box-sizing: border-box;
  border-radius: 25%;
  background: #1e7d32;
  color: #fff;
}

.qs-page .qs-progress-pin-glyph svg {
  display: block;
  width: 100%;
  height: 100%;
}

.qs-page .qs-progress-pin-z {
  display: block;
  color: #fff;
  font-family: 'Arial Rounded MT Bold', Arial, sans-serif;
  font-size: calc(var(--qs-pin-size) * 0.52);
  font-weight: 900;
  line-height: 0.9;
  transform: scaleX(1.08);
}

.qs-page .qs-progress-pin--done {
  z-index: 3;
}

.qs-page .qs-progress-pin--selected {
  --qs-pin-size: clamp(62px, calc(9 * var(--qs-progress-vmin)), 112px);
  z-index: 5;
  filter: drop-shadow(0 0.25em 0.38em rgba(0, 0, 0, 0.46));
}

.qs-page .qs-progress-pin--selected .qs-progress-pin-card {
  outline: calc(var(--qs-pin-size) * 0.045) solid rgba(255, 255, 255, 0.95);
}

.qs-page .qs-progress-pin--done .qs-progress-pin-glyph {
  background: #ff5816;
}

.qs-page .qs-progress-pin-tail {
  width: 0;
  height: 0;
  margin-top: -1px;
  border-left: calc(var(--qs-pin-size) * 0.14) solid transparent;
  border-right: calc(var(--qs-pin-size) * 0.14) solid transparent;
  border-top: calc(var(--qs-pin-size) * 0.2) solid #fff;
}

/* 고객 앱처럼 가까운 미션은 대표 핀 하나 + 우측 상단 숫자 배지로 표시한다. */
.qs-page .qs-progress-pin-count {
  position: absolute;
  z-index: 4;
  top: calc(var(--qs-pin-size) * -0.18);
  right: calc(var(--qs-pin-size) * -0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: calc(var(--qs-pin-size) * 0.62);
  height: calc(var(--qs-pin-size) * 0.62);
  padding: 0 calc(var(--qs-pin-size) * 0.12);
  box-sizing: border-box;
  border: calc(var(--qs-pin-size) * 0.07) solid #fff;
  border-radius: 999px;
  background: #ff4f64;
  box-shadow: 0 0.12em 0.2em rgba(0, 0, 0, 0.3);
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: calc(var(--qs-pin-size) * 0.34);
  font-weight: 900;
  line-height: 1;
}

/* 고객 앱처럼 같은 위치의 미션을 선택하면 현재 순서를 작은 점으로 보여준다. */
.qs-page .qs-progress-pin-cluster-tabs {
  position: absolute;
  z-index: 5;
  top: calc(var(--qs-pin-size) * -0.43);
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(var(--qs-pin-size) * 0.1);
  min-height: calc(var(--qs-pin-size) * 0.3);
  padding: calc(var(--qs-pin-size) * 0.08) calc(var(--qs-pin-size) * 0.12);
  box-sizing: border-box;
  border: max(1px, calc(var(--qs-pin-size) * 0.015)) solid #dedede;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 0.12em 0.26em rgba(0, 0, 0, 0.14);
  transform: translateX(-50%);
  pointer-events: none;
}

.qs-page .qs-progress-pin-cluster-tabs > span {
  width: calc(var(--qs-pin-size) * 0.16);
  height: calc(var(--qs-pin-size) * 0.16);
  flex: none;
  border-radius: 50%;
  background: #c8ccc8;
}

.qs-page .qs-progress-pin-cluster-tabs > span.is-active {
  background: #1e8c35;
}

.qs-page .qs-progress-pin-cluster-tabs > span.is-active.is-complete {
  background: #ff5816;
}

.qs-page .qs-icon-close,
.qs-page .qs-icon-chevron {
  display: block;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.qs-page .qs-icon-close {
  width: 56%;
  height: 56%;
  stroke-width: 2.5;
}

.qs-page .qs-icon-chevron {
  width: 62%;
  height: 62%;
  stroke-width: 2.7;
}

.qs-page .qs-progress-floor-tabs {
  position: absolute;
  z-index: 8;
  right: 5.2%;
  bottom: 3.2%;
  left: 5.2%;
  height: 7%;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  align-items: center;
  gap: 0.8%;
  box-sizing: border-box;
  padding: 0.72%;
  border-radius: clamp(12px, calc(1.65 * var(--qs-progress-vmin)), 22px);
  background: #fff;
  box-shadow: 0 calc(0.55 * var(--qs-progress-vmin)) calc(1.4 * var(--qs-progress-vmin)) rgba(28, 63, 23, 0.28);
  font-size: clamp(30px, calc(4.5 * var(--qs-progress-vmin)), 54px);
}

.qs-page .qs-progress-floor-tabs button {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 2.8em;
  height: 100%;
  padding: 0.15em 0.7em 0.22em;
  border: 0;
  border-radius: clamp(8px, calc(1.1 * var(--qs-progress-vmin)), 15px);
  background: #e9e9e9;
  color: #aaa;
  font-family: inherit;
  font-size: 1em;
  font-weight: 800;
  line-height: 1.1;
  cursor: pointer;
  overflow: visible;
}

.qs-page .qs-progress-floor-tabs button.is-active {
  background: #07870d;
  color: #fff;
}

/* 앱처럼 핀 선택 시 지도 위에 중앙 카드가 오고 양옆 카드 일부가 보이는 캐러셀. */
.qs-page .qs-mission-selection {
  position: absolute;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 11.5%;
  display: grid;
  grid-template-columns: 8% 84% 8%;
  align-items: center;
  pointer-events: none;
}

.qs-page .qs-mission-carousel {
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  gap: calc(1.8 * var(--qs-progress-vmin));
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  touch-action: pan-x;
  --qs-carousel-half-card: min(calc(41 * var(--qs-progress-vmin)), 450px);
  padding: calc(1.2 * var(--qs-progress-vmin)) calc(50% - var(--qs-carousel-half-card));
  pointer-events: auto;
}

.qs-page .qs-mission-carousel::-webkit-scrollbar {
  display: none;
}

.qs-page .qs-mission-card {
  width: min(calc(82 * var(--qs-progress-vmin)), 900px);
  min-height: min(calc(30 * var(--qs-progress-vmin)), 340px);
  max-height: min(calc(44 * var(--qs-progress-vmin)), 520px);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  padding: calc(2.4 * var(--qs-progress-vmin)) calc(3 * var(--qs-progress-vmin));
  border: calc(0.22 * var(--qs-progress-vmin)) solid rgba(225, 225, 225, 0.96);
  border-radius: calc(2.6 * var(--qs-progress-vmin));
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 calc(0.8 * var(--qs-progress-vmin)) calc(1.8 * var(--qs-progress-vmin)) rgba(27, 52, 20, 0.22);
  color: #213126;
  text-align: center;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  opacity: 0.9;
  transform: scale(0.96);
  transition: transform 0.2s ease, opacity 0.2s ease;
  overflow-y: auto;
  overscroll-behavior-y: contain;
}

.qs-page .qs-mission-card[data-selected='1'] {
  border-color: rgba(225, 225, 225, 0.96);
  opacity: 1;
  transform: scale(1);
}

.qs-page .qs-mission-card-area {
  max-width: 94%;
  padding: 0.25em 0.65em;
  border: calc(0.2 * var(--qs-progress-vmin)) solid #83bb54;
  border-radius: 0.45em;
  color: #278238;
  font-size: clamp(20px, calc(2.5 * var(--qs-progress-vmin)), 32px);
  font-weight: 800;
  line-height: 1.25;
  overflow-wrap: anywhere;
  white-space: normal;
}

.qs-page .qs-mission-card h2 {
  max-width: 100%;
  margin: calc(1.1 * var(--qs-progress-vmin)) 0 0;
  color: #087c22;
  font-family: 'AndongKaturi', sans-serif;
  font-size: clamp(32px, calc(4.1 * var(--qs-progress-vmin)), 54px);
  line-height: 1.2;
  overflow-wrap: anywhere;
  white-space: normal;
}

.qs-page .qs-mission-card p {
  min-height: 0;
  margin: calc(0.8 * var(--qs-progress-vmin)) 0 0;
  color: #344b39;
  font-size: clamp(21px, calc(2.65 * var(--qs-progress-vmin)), 34px);
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.qs-page .qs-mission-nav {
  z-index: 2;
  grid-row: 1;
  width: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);
  height: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);
  display: grid;
  place-items: center;
  box-sizing: border-box;
  min-width: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);
  min-height: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);
  padding: 0;
  border: calc(0.3 * var(--qs-progress-vmin)) solid #fff;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  background: #15923a;
  box-shadow: 0 0.4em 0.8em rgba(0, 0, 0, 0.26);
  color: #fff;
  line-height: 0;
  overflow: visible;
  pointer-events: auto;
  cursor: pointer;
}

.qs-page .qs-mission-nav--previous {
  grid-column: 1;
  justify-self: end;
}

.qs-page .qs-mission-nav--next {
  grid-column: 3;
  justify-self: start;
}


/* ── 결과 오버레이 공통 ── */
.qs-page .qs-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4vmin;
}

/* ── 완료 (대박 연출) ── */
.qs-page .qs-complete {
  background: radial-gradient(circle at 50% 40%, #047857 0%, #065f46 55%, #022c22 100%);
  animation: qs-fade-in 0.3s ease-out;
}

.qs-page .qs-complete-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2vmin;
  animation: qs-zoom-in 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.qs-page .qs-complete-emoji {
  font-size: 22vmin;
  line-height: 1;
  animation: qs-bounce 1s ease-in-out infinite;
}

.qs-page .qs-complete-title {
  margin: 0;
  font-size: 13vmin;
  font-weight: 900;
  letter-spacing: -0.02em;
  color: #fff;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
}

.qs-page .qs-complete-coupon {
  margin: 0;
  font-size: 7vmin;
  font-weight: 800;
  color: #fde047;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}

/* 색종이 */
.qs-page .qs-confetti {
  position: absolute;
  inset: 0;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
}

.qs-page .qs-confetti-piece {
  position: absolute;
  top: -8vmin;
  width: 1.4vmin;
  height: 2.2vmin;
  border-radius: 2px;
  opacity: 0.95;
  animation-name: qs-confetti-fall;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* ── 미완료 ── */
.qs-page .qs-incomplete {
  background: radial-gradient(circle at 50% 40%, #1d4ed8 0%, #1e3a8a 60%, #0b1f4d 100%);
  animation: qs-fade-in 0.3s ease-out;
  gap: 2vmin;
}

.qs-page .qs-incomplete-emoji {
  font-size: 16vmin;
  line-height: 1;
  animation: qs-bounce 1.2s ease-in-out infinite;
}

.qs-page .qs-incomplete-title {
  margin: 0;
  font-size: 11vmin;
  font-weight: 900;
  color: #fff;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.qs-page .qs-remaining-num {
  color: #fcd34d;
  font-size: 13vmin;
}

.qs-page .qs-incomplete-sub {
  margin: 0;
  font-size: 4vmin;
  font-weight: 700;
  color: #bfdbfe;
}

/* ── 세트 없음 / 에러 (중립) ── */
.qs-page .qs-neutral {
  background: radial-gradient(circle at 50% 40%, #334155 0%, #1e293b 60%, #0f172a 100%);
  animation: qs-fade-in 0.3s ease-out;
  gap: 2vmin;
}

.qs-page .qs-neutral-emoji {
  font-size: 14vmin;
  line-height: 1;
}

.qs-page .qs-neutral-title {
  margin: 0;
  font-size: 7vmin;
  font-weight: 800;
  color: #e2e8f0;
}

/* ── 키프레임 ── */
@keyframes qs-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes qs-zoom-in {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes qs-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3vmin);
  }
}

@keyframes qs-confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(115vh) rotate(720deg);
    opacity: 0.9;
  }
}

/* HTTP(카메라 차단)일 때 카메라 대신 띄우는 USB 리더기 안내 — TV용 대형 폰트.
   자체 어두운 반투명 배경으로 대기화면 배경과 무관하게 대비 확보. */
.qs-page .qs-usb-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 48px 56px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  text-align: center;
}
.qs-page .qs-usb-icon {
  font-size: 96px;
}
.qs-page .qs-usb-text {
  margin: 0;
  font-size: 40px;
  font-weight: 800;
  line-height: 1.4;
}

.qs-page .qs-progress-map-image-frame {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 1;
}

/* 회전된 진행 화면은 실제 viewport를 채운다. 지도 자체의 aspect-ratio는 유지한다. */
.qs-page[data-screen-step="mission-progress"] {
  --qs-progress-unit: min(0.0833333333vh, 0.0520833333vw);
  --qs-progress-vmin: min(1vh, 0.625vw);
  width: 100vh;
  height: 100vw;
}
.qs-page.qs-page--dev-upright[data-screen-step="mission-progress"] {
  --qs-progress-unit: min(0.0833333333vh, 0.1333333333vw);
  --qs-progress-vmin: min(1vh, 1.6vw);
  width: min(100vh, 160vw);
  height: min(160vh, 256vw);
}
/* 1200x1920 기준 상단64/좌우64/높이126. 지도 transform과 독립. */
.qs-page .qs-progress-header {
  z-index: 20;
  top: 3.333333%;
  left: 5.333333%;
  right: 5.333333%;
  height: 6.5625%;
  padding: 0 2.333333%;
  border-radius: calc(32 * var(--qs-progress-unit));
  font-size: calc(64 * var(--qs-progress-unit));
  white-space: nowrap;
  flex-shrink: 0;
}
.qs-page .qs-mission-carousel { position: relative; }

/* 긴 미션 문구는 카드 안에서 스크롤한다. flex 축소로 첫 줄이 잘리지 않게 한다. */
.qs-page .qs-mission-card { justify-content: flex-start; }
.qs-page .qs-mission-card > * { flex-shrink: 0; }

.qs-page .qs-progress-map-image-frame--full-art { overflow:visible; }
`, "",{"version":3,"sources":["webpack://./src/pages/QuestStatusPage.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;EAClD,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,UAAU;EACV,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;EAChB,qFAAqF;EACrF,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,oDAAoD;EACpD,YAAY;EACZ,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,mFAAmF;EACnF,WAAW;EACX,oFAAoF;EACpF,2BAA2B;EAC3B,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;EAClF,4EAA4E;AAC9E;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA,qCAAqC;AACrC;;;EAGE,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,8CAA8C;EAC9C,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,+BAA+B;EAC/B,uCAAuC;EACvC,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;;EAGE,iCAAiC;EACjC,wBAAwB;EACxB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kGAAkG;EAClG,wBAAwB;EACxB,sFAAsF;AACxF;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,+EAA+E;EAC/E,2BAA2B;EAC3B,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,uCAAuC;AACzC;;AAEA,sDAAsD;AACtD;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,4EAA4E;EAC9E;EACA;IACE,0FAA0F;EAC5F;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,qEAAqE;EACrE,mBAAmB;EACnB,8GAA8G;EAC9G,WAAW;EACX,uCAAuC;EACvC,iEAAiE;EACjE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,0DAA0D;EAC1D,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EAQjB;;;;;;GAMC;EACD,uBAAuB;AACzB;;AAEA;EACE,qEAAqE;EACrE,0DAA0D;EAC1D,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;;;;0CAIwC;EACxC,0BAA0B;EAC1B,uDAAuD;EACvD,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uDAAuD;EACvD,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oEAAoE;EACpE,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,8DAA8D;EAC9D,+DAA+D;EAC/D,qDAAqD;AACvD;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,uCAAuC;EACvC,0CAA0C;EAC1C,sBAAsB;EACtB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,0CAA0C;EAC1C,wEAAwE;EACxE,sBAAsB;EACtB,gEAAgE;EAChE,oBAAoB;EACpB,qCAAqC;EACrC,+CAA+C;EAC/C,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,sEAAsE;EACtE,gBAAgB;EAChB,6GAA6G;EAC7G,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,oEAAoE;EACpE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,uEAAuE;EACvE,qFAAqF;EACrF,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,0DAA0D;EAC1D,0DAA0D;EAC1D,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,8EAA8E;EAC9E,4EAA4E;EAC5E,kDAAkD;EAClD,qCAAqC;EACrC,4GAA4G;EAC5G,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yDAAyD;EACzD,qBAAqB;EACrB,cAAc;EACd,iEAAiE;EACjE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,uCAAuC;EACvC,iEAAiE;EACjE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,cAAc;EACd,kEAAkE;EAClE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,2DAA2D;EAC3D,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+DAA+D;EAC/D,gEAAgE;EAChE,UAAU;EACV,sDAAsD;EACtD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;;AAGA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qFAAqF;EACrF,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,qFAAqF;EACrF,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,qFAAqF;EACrF,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF;;AAEA;yCACyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;EACE,uDAAuD;EACvD,qCAAqC;EACrC,YAAY;EACZ,aAAa;AACf;AACA;EACE,uDAAuD;EACvD,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;AAC3B;AACA,oDAAoD;AACpD;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iDAAiD;EACjD,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;AACA,gCAAgC,kBAAkB,EAAE;;AAEpD,oDAAoD;AACpD,4BAA4B,2BAA2B,EAAE;AACzD,gCAAgC,cAAc,EAAE;;AAEhD,kDAAkD,gBAAgB,EAAE","sourcesContent":["/**\n * 퀘스트 광장 큰 TV 스타일 — 풀스크린, 대형 폰트, 화려한 연출.\n * 모든 클래스는 .qs-page 하위로 스코프해 다른 화면과 충돌 방지.\n * 단위는 vw/vmin 위주 → TV 해상도(1080p/4K)에 따라 자동 스케일.\n */\n\n.qs-viewport {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  background: #101610;\n  isolation: isolate;\n}\n\n/* 1200×1920 피그마 캔버스 밖의 여백은 동일 화면의 색감으로만 채운다. */\n.qs-ambient-background {\n  position: absolute;\n  z-index: 0;\n  inset: -5%;\n  overflow: hidden;\n  background: #101610;\n  pointer-events: none;\n}\n\n.qs-ambient-background::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(4, 12, 6, 0.3);\n}\n\n.qs-ambient-background img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(32px) saturate(0.82) brightness(0.72);\n  transform: scale(1.08);\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n/* 현장 디스플레이가 왼쪽으로 눕힌 세로형이므로 주키퍼 본부 전체를 반시계 방향으로 회전한다. */\n.qs-page {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 50%;\n  width: 100vh;\n  height: 160vh;\n  flex: none;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  transform-origin: center;\n  overflow: hidden;\n  background: radial-gradient(circle at 50% 30%, #134e4a 0%, #042f2e 70%, #021917 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n\n/* 개발 중 세로 시안을 바로 확인하는 미리보기. 기본 현장 회전값은 유지한다. */\n.qs-page.qs-page--dev-upright {\n  /* 논리 크기는 실전 회전 화면과 동일하게 두고 전체를 축소해 비율·vmin을 보존한다. */\n  width: 100vh;\n  height: 160vh;\n  transform: translate(-50%, -50%) scale(0.625);\n}\n\n.qs-hidden-home-exit {\n  position: fixed;\n  z-index: 100002;\n  top: 0;\n  left: 0;\n  width: 96px;\n  height: 96px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  opacity: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qs-dev-toolbar {\n  position: fixed;\n  z-index: 100001;\n  left: 18px;\n  bottom: 18px;\n  display: grid;\n  min-width: 420px;\n  gap: 10px;\n  padding: 12px;\n  box-sizing: border-box;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 20px;\n  background: linear-gradient(145deg, rgba(15, 23, 42, 0.94), rgba(25, 39, 35, 0.92));\n  color: #fff;\n  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qs-dev-toolbar-heading {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 0 4px;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n  letter-spacing: -0.01em;\n}\n\n.qs-dev-toolbar-heading strong {\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.qs-dev-menu-home {\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  margin-left: auto;\n  padding: 0 9px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.09);\n  color: #f8fafc;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 850;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 130ms ease, transform 130ms ease;\n}\n\n.qs-dev-menu-home:hover {\n  background: rgba(255, 255, 255, 0.17);\n}\n\n.qs-dev-menu-home:active {\n  transform: translateY(1px) scale(0.97);\n}\n\n.qs-dev-menu-home:focus-visible {\n  outline: 2px solid #facc15;\n  outline-offset: 2px;\n}\n\n.qs-dev-menu-home svg {\n  width: 14px;\n  height: 14px;\n  fill: currentColor;\n}\n\n.qs-dev-toolbar-badge {\n  padding: 4px 7px;\n  border-radius: 7px;\n  background: linear-gradient(135deg, #a3e635, #22c55e);\n  color: #102218;\n  font-size: 11px;\n  font-weight: 950;\n  line-height: 1;\n  letter-spacing: 0.08em;\n}\n\n.qs-dev-toolbar-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.qs-dev-tool-button {\n  display: inline-flex;\n  min-width: 0;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 13px;\n  color: #f8fafc;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 5px 12px rgba(0, 0, 0, 0.18);\n  transition: transform 130ms ease, filter 130ms ease, border-color 130ms ease;\n}\n\n.qs-dev-tool-button:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  filter: brightness(1.08);\n}\n\n.qs-dev-tool-button:active {\n  transform: translateY(2px) scale(0.98);\n  filter: brightness(0.92);\n}\n\n.qs-dev-tool-button:focus-visible {\n  outline: 3px solid #facc15;\n  outline-offset: 2px;\n}\n\n.qs-dev-qr-button--incomplete {\n  background: linear-gradient(145deg, #2563eb, #1d4ed8);\n}\n\n.qs-dev-qr-button--complete {\n  background: linear-gradient(145deg, #f97316, #ea580c);\n}\n\n.qs-dev-tool-status {\n  width: 9px;\n  height: 9px;\n  flex: 0 0 auto;\n  border: 2px solid rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);\n}\n\n.qs-dev-tool-check {\n  display: grid;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  color: #c2410c;\n  font-size: 13px;\n  font-weight: 950;\n}\n\n.qs-dev-orientation-toggle {\n  margin-left: auto;\n  background: linear-gradient(145deg, #334155, #1e293b);\n}\n\n.qs-dev-orientation-toggle svg {\n  display: block;\n  width: 19px;\n  height: 19px;\n  flex: 0 0 auto;\n  fill: currentColor;\n  transition: transform 180ms ease;\n}\n\n.qs-dev-orientation-toggle.is-upright svg {\n  transform: rotate(90deg);\n}\n\n.qs-dev-home-button {\n  background: linear-gradient(145deg, #15803d, #166534);\n}\n\n.qs-dev-home-button svg {\n  display: block;\n  width: 19px;\n  height: 19px;\n  flex: 0 0 auto;\n  fill: currentColor;\n}\n\n/* ── 대기 화면 ── */\n.qs-page .qs-idle {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #000;\n}\n\n.qs-page .qs-screen-frame {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  flex: 0 0 auto;\n  contain: layout paint;\n  isolation: isolate;\n}\n\n.qs-page .qs-idle-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.qs-page .qs-waiting-screen-loading {\n  width: 100%;\n  height: 100%;\n  background: #000;\n}\n\n.qs-page .qs-waiting-screen-error {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n  color: #fff;\n  background: #101b12;\n  font-size: clamp(24px, 3vw, 48px);\n  text-align: center;\n}\n\n/* 선물 받기 직후 정적 배경·큐브를 대체하는 5초 오픈 연출. 로고와 버튼은 상위 레이어에 유지한다. */\n.qs-page .qs-gift-opening-video {\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  opacity: 0;\n  pointer-events: none;\n  transform: none;\n}\n\n.qs-page .qs-gift-opening-video.is-playing {\n  animation: qs-gift-opening-reveal 240ms ease-out both;\n}\n\n.qs-page .qs-gift-opening-video.is-final {\n  opacity: 1;\n}\n\n/* 완료 영상 종료 뒤 큐브 영상의 첫 프레임만 정지 상태로 보여준다. */\n.qs-page .qs-gift-opening-video.is-ready {\n  opacity: 1;\n}\n\n/* 은화 획득 단계는 별도 UI 없이 영상만 전면에 노출한다. */\n.qs-page .qs-silver-reward-video,\n.qs-page .qs-coupon-reveal-video,\n.qs-page .qs-egg-hatch-video {\n  z-index: 3;\n}\n\n/* 마지막 프레임 위에 말풍선(z-index 2)과 확인 버튼(z-index 4)을 올린다. */\n.qs-page .qs-animal-reveal-video {\n  z-index: 1;\n}\n\n/* 피그마에서 분리 전달된 보상 화면 레이어. */\n.qs-page .qs-reward-headline-image {\n  position: absolute;\n  z-index: 2;\n  right: 0;\n  left: 0;\n  height: auto;\n  margin-inline: auto;\n  pointer-events: none;\n  user-select: none;\n  backface-visibility: hidden;\n  -webkit-user-drag: none;\n}\n\n.qs-page .qs-reward-headline-image--complete-character {\n  top: 5.2%;\n  width: 76%;\n}\n\n.qs-page .qs-reward-headline-image--coin,\n.qs-page .qs-reward-headline-image--coupon,\n.qs-page .qs-reward-headline-image--egg {\n  top: 4.1667%;\n  width: 86.6667%;\n}\n\n/* 문구가 합쳐진 시안 대신 빈 말풍선 위에 서버의 실제 보상값을 표시한다. */\n.qs-page .qs-reward-dynamic-headline {\n  position: absolute;\n  z-index: 2;\n  top: 4.1667%;\n  right: 0;\n  left: 0;\n  width: 86.6667%;\n  height: auto;\n  margin-inline: auto;\n  pointer-events: none;\n  user-select: none;\n  backface-visibility: hidden;\n}\n\n.qs-page .qs-reward-dynamic-headline-bubble {\n  display: block;\n  width: 100%;\n  height: auto;\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.qs-page .qs-reward-dynamic-headline-text {\n  position: absolute;\n  top: 5%;\n  right: 7%;\n  bottom: 22%;\n  left: 7%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  overflow: hidden;\n  color: #079719;\n  font-family: 'Jua', 'Noto Sans KR', sans-serif;\n  font-size: clamp(56px, 9vmin, 104px);\n  font-weight: 700;\n  line-height: 1.04;\n  text-align: center;\n  text-wrap: balance;\n  word-break: keep-all;\n  filter: drop-shadow(0 0.08em 0 rgba(255, 255, 255, 0.55));\n}\n\n.qs-page .qs-reward-hero {\n  --qs-reward-float-duration: 3.4s;\n  --qs-reward-float-y: -5%;\n  --qs-reward-float-tilt: 0.8deg;\n  --qs-reward-float-tilt-reverse: -0.55deg;\n  position: absolute;\n  z-index: 2;\n  right: 0;\n  left: 0;\n  height: auto;\n  margin-inline: auto;\n  pointer-events: none;\n  user-select: none;\n  backface-visibility: hidden;\n  isolation: isolate;\n}\n\n.qs-page .qs-reward-hero--complete-character {\n  --qs-reward-float-duration: 3.6s;\n  --qs-reward-float-y: -2.6%;\n  --qs-reward-float-tilt: 0.75deg;\n  --qs-reward-float-tilt-reverse: -0.5deg;\n  top: 25.5%;\n  width: 62%;\n}\n\n.qs-page .qs-reward-hero--opening {\n  animation: qs-gift-opening-static-fade 240ms ease-out both;\n}\n\n.qs-page .qs-reward-hero--coin,\n.qs-page .qs-reward-hero--coupon,\n.qs-page .qs-reward-hero--egg {\n  --qs-reward-float-duration: 3.45s;\n  --qs-reward-float-y: -5%;\n  --qs-reward-float-tilt: 1.15deg;\n  --qs-reward-float-tilt-reverse: -0.85deg;\n}\n\n.qs-page .qs-reward-hero--coin {\n  top: 27.5%;\n  width: 68.3333%;\n}\n\n.qs-page .qs-reward-hero--coupon {\n  top: 27.5%;\n  width: 52.7292%;\n}\n\n.qs-page .qs-reward-hero--egg {\n  top: 29%;\n  width: 55%;\n}\n\n/* 모바일과 같은 animal_profile.image_url 대체 노출. 전용 획득 영상이 없는 동물만 사용한다. */\n.qs-page .qs-animal-profile-fallback {\n  position: absolute;\n  z-index: 2;\n  top: 27.5%;\n  left: 50%;\n  display: flex;\n  width: 56%;\n  aspect-ratio: 1;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 2.4%;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1.2rem 2rem rgba(61, 35, 25, 0.18);\n  transform: translateX(-50%);\n  animation: qs-reward-pop-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.qs-page .qs-animal-profile-fallback img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n/* 오브젝트 높이에 맞춰 작아졌다 커지는 그림자로 부유감을 보강한다. */\n.qs-page .qs-reward-hero::after {\n  content: '';\n  position: absolute;\n  z-index: 0;\n  right: 22%;\n  bottom: -3.5%;\n  left: 22%;\n  height: 7%;\n  border-radius: 50%;\n  background: radial-gradient(ellipse at center, rgba(54, 24, 17, 0.28) 0%, rgba(54, 24, 17, 0) 72%);\n  transform-origin: center;\n  animation: qs-reward-float-shadow var(--qs-reward-float-duration) ease-in-out infinite;\n}\n\n.qs-page .qs-reward-hero--tada {\n  animation: qs-reward-pop-in 620ms cubic-bezier(0.22, 1, 0.36, 1) backwards;\n}\n\n.qs-page .qs-reward-hero--tada .qs-reward-hero-image {\n  animation-delay: 640ms;\n}\n\n.qs-page .qs-reward-hero--tada::after {\n  animation-delay: 640ms;\n}\n\n/* 보상 오브젝트는 첫 등장 연출만 사용하고, 노출 후에는 제자리에 멈춘다. */\n.qs-page .qs-reward-hero--coin .qs-reward-hero-image,\n.qs-page .qs-reward-hero--coupon .qs-reward-hero-image,\n.qs-page .qs-reward-hero--egg .qs-reward-hero-image {\n  animation: none;\n}\n\n.qs-page .qs-reward-hero--coin::after,\n.qs-page .qs-reward-hero--coupon::after,\n.qs-page .qs-reward-hero--egg::after {\n  display: none;\n}\n\n.qs-page .qs-reward-hero-image {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: auto;\n  pointer-events: none;\n  user-select: none;\n  animation: qs-reward-float var(--qs-reward-float-duration) ease-in-out infinite;\n  backface-visibility: hidden;\n  transform: translate3d(0, 0, 0);\n  will-change: transform;\n  -webkit-user-drag: none;\n}\n\n.qs-page .qs-reward-button-visual {\n  position: absolute;\n  z-index: 4;\n  display: block;\n  left: 15%;\n  right: 15%;\n  bottom: 4.1667%;\n  width: auto;\n  height: 14.5833%;\n  min-height: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  line-height: 0;\n  cursor: pointer;\n  pointer-events: auto;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qs-page .qs-reward-button-visual.is-pressed .qs-reward-button-image {\n  animation: qs-reward-button-press 220ms ease-out both;\n}\n\n.qs-page .qs-reward-button-image {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  cursor: pointer;\n  pointer-events: auto;\n  user-select: none;\n  transform-origin: center;\n  backface-visibility: hidden;\n  will-change: transform;\n  -webkit-user-drag: none;\n}\n\n/* 저사양 태블릿의 지도 이동 중에는 전체 화면 32px 블러 합성 비용을 제거한다. */\n.qs-viewport--mission-map .qs-ambient-background img {\n  filter: saturate(0.82) brightness(0.64);\n}\n\n/* 버튼 이미지 요소 자체를 클릭 영역으로 사용해 보이는 크기와 hit box를 일치시킨다. */\n.qs-page .qs-image-action {\n  cursor: pointer;\n}\n\n.qs-page .qs-image-action:focus-visible {\n  outline: 4px solid rgba(255, 255, 255, 0.9);\n  outline-offset: 4px;\n}\n\n.qs-page .qs-image-action:disabled {\n  cursor: default;\n}\n\n@keyframes qs-reward-pop-in {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 7%, 0);\n  }\n  58% {\n    opacity: 1;\n    transform: translate3d(0, -1.4%, 0);\n  }\n  80% {\n    transform: translate3d(0, 0.5%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes qs-gift-opening-reveal {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes qs-gift-opening-static-fade {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes qs-reward-float {\n  0%,\n  100% {\n    transform: translate3d(0, 1%, 0) rotate(var(--qs-reward-float-tilt-reverse));\n  }\n  50% {\n    transform: translate3d(0, var(--qs-reward-float-y), 0) rotate(var(--qs-reward-float-tilt));\n  }\n}\n\n@keyframes qs-reward-float-shadow {\n  0%,\n  100% {\n    opacity: 0.28;\n    transform: scale3d(1, 0.82, 1);\n  }\n  50% {\n    opacity: 0.12;\n    transform: scale3d(0.72, 0.58, 1);\n  }\n}\n\n@keyframes qs-reward-button-press {\n  0% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(0.94);\n  }\n  100% {\n    transform: scale(1.02);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .qs-page .qs-reward-hero--tada,\n  .qs-page .qs-reward-hero--opening,\n  .qs-page .qs-gift-opening-video.is-playing,\n  .qs-page .qs-reward-hero-image,\n  .qs-page .qs-reward-hero::after,\n  .qs-page .qs-reward-button-visual.is-pressed .qs-reward-button-image {\n    animation: none;\n  }\n\n  .qs-page .qs-gift-opening-video.is-playing {\n    opacity: 1;\n  }\n\n  .qs-page .qs-reward-hero--opening {\n    opacity: 0;\n  }\n}\n\n@media (max-width: 720px) {\n  .qs-dev-toolbar {\n    left: 10px;\n    bottom: 10px;\n    min-width: 0;\n    max-width: calc(100vw - 20px);\n    transform: scale(0.9);\n    transform-origin: left bottom;\n  }\n\n  .qs-dev-tool-button {\n    padding-inline: 10px;\n    font-size: 12px;\n  }\n}\n\n.qs-page .qs-idle-busy {\n  position: absolute;\n  z-index: 2;\n  left: 50%;\n  bottom: 5%;\n  transform: translateX(-50%);\n  margin: 0;\n  padding: 0.5em 0.9em;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.66);\n  font-size: 3vmin;\n  font-weight: 700;\n  color: #fcd34d;\n  white-space: nowrap;\n}\n\n/* ── QR 회원별 실제 미션 진행 지도 ── */\n.qs-page .qs-progress {\n  position: absolute;\n  inset: 0;\n  box-sizing: border-box;\n  padding: 0;\n  background: #6f8f4a;\n  color: #fff;\n  pointer-events: auto;\n  isolation: isolate;\n}\n\n\n/* 지도와 문구가 숲 배경에 묻히지 않으면서 원본 일러스트는 보이게 한다. */\n.qs-page .qs-progress::after {\n  content: '';\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(34, 76, 30, 0.18) 0%,\n    rgba(61, 101, 43, 0.06) 48%,\n    rgba(25, 62, 25, 0.2) 100%\n  );\n}\n\n.qs-page .qs-progress-header {\n  position: absolute;\n  z-index: 6;\n  top: 3.6%;\n  right: 5.2%;\n  left: 5.2%;\n  height: 7.1%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding: 0 2.7%;\n  border-radius: clamp(15px, calc(2.1 * var(--qs-progress-vmin)), 28px);\n  background: #005b08;\n  box-shadow: 0 calc(0.45 * var(--qs-progress-vmin)) calc(1.15 * var(--qs-progress-vmin)) rgba(20, 55, 20, 0.24);\n  color: #fff;\n  font-family: 'AndongKaturi', sans-serif;\n  font-size: clamp(30px, calc(4.4 * var(--qs-progress-vmin)), 56px);\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.02em;\n}\n\n.qs-page .qs-progress-header strong {\n  flex: none;\n  color: #fff;\n  font: inherit;\n  font-variant-numeric: tabular-nums;\n}\n\n.qs-page .qs-progress-map-area {\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  min-height: 0;\n  width: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 0;\n  touch-action: none;\n  cursor: grab;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qs-page .qs-progress-map-area:active {\n  cursor: grabbing;\n}\n\n/* 이미지 자체가 좌표계다. 핀의 left/top %가 뷰포트 여백 때문에 어긋나지 않게 한다. */\n.qs-page .qs-progress-map-canvas {\n  position: relative;\n  width: 100%;\n  flex: none;\n  line-height: 0;\n  overflow: visible;\n  transform-origin: 0 0;\n  transition: transform 0.42s cubic-bezier(0.2, 0.8, 0.2, 1);\n  will-change: transform;\n  backface-visibility: hidden;\n  isolation: isolate;\n}\n\n.qs-page .qs-progress-map-area:active .qs-progress-map-canvas {\n  transition: none;\n}\n\n.qs-page .qs-progress-map-image {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  border-radius: 0;\n  user-select: none;\n  -webkit-mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    #000 2.5%,\n    #000 97.5%,\n    transparent 100%\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    #000 2.5%,\n    #000 97.5%,\n    transparent 100%\n  );\n  -webkit-user-drag: none;\n}\n\n.qs-page .qs-progress-pin {\n  --qs-pin-size: clamp(46px, calc(6.2 * var(--qs-progress-vmin)), 82px);\n  --qs-pin-zoom-compensation: var(--qs-map-inverse-scale, 1);\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translate3d(\n    calc(-50% + var(--qs-pin-dx, 0px)),\n    calc(-100% + var(--qs-pin-dy, 0px)),\n    0\n  ) scale(var(--qs-pin-zoom-compensation));\n  transform-origin: 50% 100%;\n  filter: drop-shadow(0 0.12em 0.2em rgba(0, 0, 0, 0.42));\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  line-height: 1;\n  -webkit-tap-highlight-color: transparent;\n  transition: filter 0.2s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n\n.qs-page .qs-progress-pin-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--qs-pin-size);\n  height: var(--qs-pin-size);\n  padding: calc(var(--qs-pin-size) * 0.12);\n  box-sizing: border-box;\n  border-radius: 32%;\n  background: #fff;\n}\n\n.qs-page .qs-progress-pin-glyph {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 16%;\n  box-sizing: border-box;\n  border-radius: 25%;\n  background: #1e7d32;\n  color: #fff;\n}\n\n.qs-page .qs-progress-pin-glyph svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.qs-page .qs-progress-pin-z {\n  display: block;\n  color: #fff;\n  font-family: 'Arial Rounded MT Bold', Arial, sans-serif;\n  font-size: calc(var(--qs-pin-size) * 0.52);\n  font-weight: 900;\n  line-height: 0.9;\n  transform: scaleX(1.08);\n}\n\n.qs-page .qs-progress-pin--done {\n  z-index: 3;\n}\n\n.qs-page .qs-progress-pin--selected {\n  --qs-pin-size: clamp(62px, calc(9 * var(--qs-progress-vmin)), 112px);\n  z-index: 5;\n  filter: drop-shadow(0 0.25em 0.38em rgba(0, 0, 0, 0.46));\n}\n\n.qs-page .qs-progress-pin--selected .qs-progress-pin-card {\n  outline: calc(var(--qs-pin-size) * 0.045) solid rgba(255, 255, 255, 0.95);\n}\n\n.qs-page .qs-progress-pin--done .qs-progress-pin-glyph {\n  background: #ff5816;\n}\n\n.qs-page .qs-progress-pin-tail {\n  width: 0;\n  height: 0;\n  margin-top: -1px;\n  border-left: calc(var(--qs-pin-size) * 0.14) solid transparent;\n  border-right: calc(var(--qs-pin-size) * 0.14) solid transparent;\n  border-top: calc(var(--qs-pin-size) * 0.2) solid #fff;\n}\n\n/* 고객 앱처럼 가까운 미션은 대표 핀 하나 + 우측 상단 숫자 배지로 표시한다. */\n.qs-page .qs-progress-pin-count {\n  position: absolute;\n  z-index: 4;\n  top: calc(var(--qs-pin-size) * -0.18);\n  right: calc(var(--qs-pin-size) * -0.28);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: calc(var(--qs-pin-size) * 0.62);\n  height: calc(var(--qs-pin-size) * 0.62);\n  padding: 0 calc(var(--qs-pin-size) * 0.12);\n  box-sizing: border-box;\n  border: calc(var(--qs-pin-size) * 0.07) solid #fff;\n  border-radius: 999px;\n  background: #ff4f64;\n  box-shadow: 0 0.12em 0.2em rgba(0, 0, 0, 0.3);\n  color: #fff;\n  font-family: Arial, sans-serif;\n  font-size: calc(var(--qs-pin-size) * 0.34);\n  font-weight: 900;\n  line-height: 1;\n}\n\n/* 고객 앱처럼 같은 위치의 미션을 선택하면 현재 순서를 작은 점으로 보여준다. */\n.qs-page .qs-progress-pin-cluster-tabs {\n  position: absolute;\n  z-index: 5;\n  top: calc(var(--qs-pin-size) * -0.43);\n  left: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: calc(var(--qs-pin-size) * 0.1);\n  min-height: calc(var(--qs-pin-size) * 0.3);\n  padding: calc(var(--qs-pin-size) * 0.08) calc(var(--qs-pin-size) * 0.12);\n  box-sizing: border-box;\n  border: max(1px, calc(var(--qs-pin-size) * 0.015)) solid #dedede;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 0.12em 0.26em rgba(0, 0, 0, 0.14);\n  transform: translateX(-50%);\n  pointer-events: none;\n}\n\n.qs-page .qs-progress-pin-cluster-tabs > span {\n  width: calc(var(--qs-pin-size) * 0.16);\n  height: calc(var(--qs-pin-size) * 0.16);\n  flex: none;\n  border-radius: 50%;\n  background: #c8ccc8;\n}\n\n.qs-page .qs-progress-pin-cluster-tabs > span.is-active {\n  background: #1e8c35;\n}\n\n.qs-page .qs-progress-pin-cluster-tabs > span.is-active.is-complete {\n  background: #ff5816;\n}\n\n.qs-page .qs-icon-close,\n.qs-page .qs-icon-chevron {\n  display: block;\n  flex: none;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.qs-page .qs-icon-close {\n  width: 56%;\n  height: 56%;\n  stroke-width: 2.5;\n}\n\n.qs-page .qs-icon-chevron {\n  width: 62%;\n  height: 62%;\n  stroke-width: 2.7;\n}\n\n.qs-page .qs-progress-floor-tabs {\n  position: absolute;\n  z-index: 8;\n  right: 5.2%;\n  bottom: 3.2%;\n  left: 5.2%;\n  height: 7%;\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  align-items: center;\n  gap: 0.8%;\n  box-sizing: border-box;\n  padding: 0.72%;\n  border-radius: clamp(12px, calc(1.65 * var(--qs-progress-vmin)), 22px);\n  background: #fff;\n  box-shadow: 0 calc(0.55 * var(--qs-progress-vmin)) calc(1.4 * var(--qs-progress-vmin)) rgba(28, 63, 23, 0.28);\n  font-size: clamp(30px, calc(4.5 * var(--qs-progress-vmin)), 54px);\n}\n\n.qs-page .qs-progress-floor-tabs button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  min-width: 2.8em;\n  height: 100%;\n  padding: 0.15em 0.7em 0.22em;\n  border: 0;\n  border-radius: clamp(8px, calc(1.1 * var(--qs-progress-vmin)), 15px);\n  background: #e9e9e9;\n  color: #aaa;\n  font-family: inherit;\n  font-size: 1em;\n  font-weight: 800;\n  line-height: 1.1;\n  cursor: pointer;\n  overflow: visible;\n}\n\n.qs-page .qs-progress-floor-tabs button.is-active {\n  background: #07870d;\n  color: #fff;\n}\n\n/* 앱처럼 핀 선택 시 지도 위에 중앙 카드가 오고 양옆 카드 일부가 보이는 캐러셀. */\n.qs-page .qs-mission-selection {\n  position: absolute;\n  z-index: 10;\n  left: 0;\n  right: 0;\n  bottom: 11.5%;\n  display: grid;\n  grid-template-columns: 8% 84% 8%;\n  align-items: center;\n  pointer-events: none;\n}\n\n.qs-page .qs-mission-carousel {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  display: flex;\n  gap: calc(1.8 * var(--qs-progress-vmin));\n  overflow-x: auto;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n  touch-action: pan-x;\n  --qs-carousel-half-card: min(calc(41 * var(--qs-progress-vmin)), 450px);\n  padding: calc(1.2 * var(--qs-progress-vmin)) calc(50% - var(--qs-carousel-half-card));\n  pointer-events: auto;\n}\n\n.qs-page .qs-mission-carousel::-webkit-scrollbar {\n  display: none;\n}\n\n.qs-page .qs-mission-card {\n  width: min(calc(82 * var(--qs-progress-vmin)), 900px);\n  min-height: min(calc(30 * var(--qs-progress-vmin)), 340px);\n  max-height: min(calc(44 * var(--qs-progress-vmin)), 520px);\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  justify-content: center;\n  padding: calc(2.4 * var(--qs-progress-vmin)) calc(3 * var(--qs-progress-vmin));\n  border: calc(0.22 * var(--qs-progress-vmin)) solid rgba(225, 225, 225, 0.96);\n  border-radius: calc(2.6 * var(--qs-progress-vmin));\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 calc(0.8 * var(--qs-progress-vmin)) calc(1.8 * var(--qs-progress-vmin)) rgba(27, 52, 20, 0.22);\n  color: #213126;\n  text-align: center;\n  scroll-snap-align: center;\n  scroll-snap-stop: always;\n  opacity: 0.9;\n  transform: scale(0.96);\n  transition: transform 0.2s ease, opacity 0.2s ease;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n}\n\n.qs-page .qs-mission-card[data-selected='1'] {\n  border-color: rgba(225, 225, 225, 0.96);\n  opacity: 1;\n  transform: scale(1);\n}\n\n.qs-page .qs-mission-card-area {\n  max-width: 94%;\n  padding: 0.25em 0.65em;\n  border: calc(0.2 * var(--qs-progress-vmin)) solid #83bb54;\n  border-radius: 0.45em;\n  color: #278238;\n  font-size: clamp(20px, calc(2.5 * var(--qs-progress-vmin)), 32px);\n  font-weight: 800;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.qs-page .qs-mission-card h2 {\n  max-width: 100%;\n  margin: calc(1.1 * var(--qs-progress-vmin)) 0 0;\n  color: #087c22;\n  font-family: 'AndongKaturi', sans-serif;\n  font-size: clamp(32px, calc(4.1 * var(--qs-progress-vmin)), 54px);\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.qs-page .qs-mission-card p {\n  min-height: 0;\n  margin: calc(0.8 * var(--qs-progress-vmin)) 0 0;\n  color: #344b39;\n  font-size: clamp(21px, calc(2.65 * var(--qs-progress-vmin)), 34px);\n  font-weight: 700;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n  white-space: pre-line;\n}\n\n.qs-page .qs-mission-nav {\n  z-index: 2;\n  grid-row: 1;\n  width: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);\n  height: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  min-width: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);\n  min-height: clamp(52px, calc(7 * var(--qs-progress-vmin)), 82px);\n  padding: 0;\n  border: calc(0.3 * var(--qs-progress-vmin)) solid #fff;\n  border-radius: 50%;\n  aspect-ratio: 1 / 1;\n  background: #15923a;\n  box-shadow: 0 0.4em 0.8em rgba(0, 0, 0, 0.26);\n  color: #fff;\n  line-height: 0;\n  overflow: visible;\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n.qs-page .qs-mission-nav--previous {\n  grid-column: 1;\n  justify-self: end;\n}\n\n.qs-page .qs-mission-nav--next {\n  grid-column: 3;\n  justify-self: start;\n}\n\n\n/* ── 결과 오버레이 공통 ── */\n.qs-page .qs-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 4vmin;\n}\n\n/* ── 완료 (대박 연출) ── */\n.qs-page .qs-complete {\n  background: radial-gradient(circle at 50% 40%, #047857 0%, #065f46 55%, #022c22 100%);\n  animation: qs-fade-in 0.3s ease-out;\n}\n\n.qs-page .qs-complete-inner {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2vmin;\n  animation: qs-zoom-in 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n\n.qs-page .qs-complete-emoji {\n  font-size: 22vmin;\n  line-height: 1;\n  animation: qs-bounce 1s ease-in-out infinite;\n}\n\n.qs-page .qs-complete-title {\n  margin: 0;\n  font-size: 13vmin;\n  font-weight: 900;\n  letter-spacing: -0.02em;\n  color: #fff;\n  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);\n}\n\n.qs-page .qs-complete-coupon {\n  margin: 0;\n  font-size: 7vmin;\n  font-weight: 800;\n  color: #fde047;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);\n}\n\n/* 색종이 */\n.qs-page .qs-confetti {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.qs-page .qs-confetti-piece {\n  position: absolute;\n  top: -8vmin;\n  width: 1.4vmin;\n  height: 2.2vmin;\n  border-radius: 2px;\n  opacity: 0.95;\n  animation-name: qs-confetti-fall;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n/* ── 미완료 ── */\n.qs-page .qs-incomplete {\n  background: radial-gradient(circle at 50% 40%, #1d4ed8 0%, #1e3a8a 60%, #0b1f4d 100%);\n  animation: qs-fade-in 0.3s ease-out;\n  gap: 2vmin;\n}\n\n.qs-page .qs-incomplete-emoji {\n  font-size: 16vmin;\n  line-height: 1;\n  animation: qs-bounce 1.2s ease-in-out infinite;\n}\n\n.qs-page .qs-incomplete-title {\n  margin: 0;\n  font-size: 11vmin;\n  font-weight: 900;\n  color: #fff;\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n}\n\n.qs-page .qs-remaining-num {\n  color: #fcd34d;\n  font-size: 13vmin;\n}\n\n.qs-page .qs-incomplete-sub {\n  margin: 0;\n  font-size: 4vmin;\n  font-weight: 700;\n  color: #bfdbfe;\n}\n\n/* ── 세트 없음 / 에러 (중립) ── */\n.qs-page .qs-neutral {\n  background: radial-gradient(circle at 50% 40%, #334155 0%, #1e293b 60%, #0f172a 100%);\n  animation: qs-fade-in 0.3s ease-out;\n  gap: 2vmin;\n}\n\n.qs-page .qs-neutral-emoji {\n  font-size: 14vmin;\n  line-height: 1;\n}\n\n.qs-page .qs-neutral-title {\n  margin: 0;\n  font-size: 7vmin;\n  font-weight: 800;\n  color: #e2e8f0;\n}\n\n/* ── 키프레임 ── */\n@keyframes qs-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes qs-zoom-in {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes qs-bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-3vmin);\n  }\n}\n\n@keyframes qs-confetti-fall {\n  0% {\n    transform: translateY(0) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(115vh) rotate(720deg);\n    opacity: 0.9;\n  }\n}\n\n/* HTTP(카메라 차단)일 때 카메라 대신 띄우는 USB 리더기 안내 — TV용 대형 폰트.\n   자체 어두운 반투명 배경으로 대기화면 배경과 무관하게 대비 확보. */\n.qs-page .qs-usb-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 48px 56px;\n  border-radius: 24px;\n  background: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  text-align: center;\n}\n.qs-page .qs-usb-icon {\n  font-size: 96px;\n}\n.qs-page .qs-usb-text {\n  margin: 0;\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 1.4;\n}\n\n.qs-page .qs-progress-map-image-frame {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  z-index: 1;\n}\n\n/* 회전된 진행 화면은 실제 viewport를 채운다. 지도 자체의 aspect-ratio는 유지한다. */\n.qs-page[data-screen-step=\"mission-progress\"] {\n  --qs-progress-unit: min(0.0833333333vh, 0.0520833333vw);\n  --qs-progress-vmin: min(1vh, 0.625vw);\n  width: 100vh;\n  height: 100vw;\n}\n.qs-page.qs-page--dev-upright[data-screen-step=\"mission-progress\"] {\n  --qs-progress-unit: min(0.0833333333vh, 0.1333333333vw);\n  --qs-progress-vmin: min(1vh, 1.6vw);\n  width: min(100vh, 160vw);\n  height: min(160vh, 256vw);\n}\n/* 1200x1920 기준 상단64/좌우64/높이126. 지도 transform과 독립. */\n.qs-page .qs-progress-header {\n  z-index: 20;\n  top: 3.333333%;\n  left: 5.333333%;\n  right: 5.333333%;\n  height: 6.5625%;\n  padding: 0 2.333333%;\n  border-radius: calc(32 * var(--qs-progress-unit));\n  font-size: calc(64 * var(--qs-progress-unit));\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.qs-page .qs-mission-carousel { position: relative; }\n\n/* 긴 미션 문구는 카드 안에서 스크롤한다. flex 축소로 첫 줄이 잘리지 않게 한다. */\n.qs-page .qs-mission-card { justify-content: flex-start; }\n.qs-page .qs-mission-card > * { flex-shrink: 0; }\n\n.qs-page .qs-progress-map-image-frame--full-art { overflow:visible; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
